import extend from './extend'

const config = {
  locale: 'en',
  stripeToken: 'pk_live_obSYSIXeYgW5YQeoSUsPUZni',
  auth: {
    //Register
    registerIsEnabled: false,
    registerByUsername: false,
    registerByEmail: false,
    registerByMobile: true,

    //Login
    loginByUsername: false,
    loginByEmail: false,
    loginByMobile: true,
    resetPasswordIsEnabled: false
  },
  files: {
    baseurlimage: 'https://www.menupoly.com/',
    thumbsAreEnabled: false,
    staticUrl: '/Dashboard/'
  },
  rootUserName: '0000',
  apiServer: 'www.menupoly.com/api',
  websiteUrl: 'https://www.menupoly.com',
  printJspmLisence: 'https://www.menupoly.com/jspm',
  ssl: true,
  homeUrl: '/dashboard',
  timeZone: {
    text: 'North America/New York',
    value: '-05:00'
  }
}

extend(config)
export default config
